import {Component, HostListener, OnInit} from '@angular/core';
import {RestapiService} from '../../../../services/restapi.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FooterService} from '../../../../services/footer.service';
import {MustMatch} from '../../../../validators/must-match.validator';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-endless-blow-forgot-password',
  templateUrl: './endless-blow-reset-password.component.html',
  styleUrls: ['./endless-blow-reset-password.component.css']
})
export class EndlessBlowResetPasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  footerHeight: number;
  tokenFromUrl: string;
  data: string;
  waitForResponse: string;

  constructor(private restapiService: RestapiService, private formBuilder: FormBuilder, private footerService: FooterService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.tokenFromUrl = params['token'];
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    setTimeout(() => {
      this.footerHeight = this.footerService.getFooterHeight();
    }, 500);
  }

  ngOnInit() {
    this.footerHeight = this.footerService.getFooterHeight();
    this.changePasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
  }

  submitFunc() {
    if(this.changePasswordForm.valid) this.waitForResponse = 'Wait for response';
    this.data = '';
    if (this.changePasswordForm.invalid) {
      console.log('Password validation invalid')
      return;
    }
    console.log('Password validation correct')
    const response = this.restapiService.postResetPassword(this.tokenFromUrl, this.changePasswordForm.controls['password'].value);
    response.subscribe(data => {
      this.data = data;
      this.waitForResponse = '';
      console.log(JSON.stringify(data));
      },
      error => {
      this.data = error.error.text;
      this.waitForResponse = '';
      console.log(error.error.text);
    });
  }
}
